export default "assets/bg_pattern_grey-bf26b528.jpg";